import { useMutation } from '@tanstack/react-query'
import { leaveHelpRequest } from '../apis/api-assignation'
import { useUI } from '../context/UIContext'
import { useTranslation } from 'react-i18next'
import { notifyToMyTeam } from '../helpers/commandChannel'
import { useZoomContext } from '../context/ZoomContext'

export const useHRLeaveRequest = () => {
    const { t } = useTranslation('notifications')
    const { showError } = useUI()
    const { commandChannel } = useZoomContext()
    const { mutate: leaveHR, ...rest } = useMutation({
        mutationFn: leaveHelpRequest,

        onSuccess: async () => {
            const message = {
                type: 'mentor_ai',
                action: 'hr_ended',
            }
            await notifyToMyTeam({ message, commandChannel })
        },

        onError(error) {
            showError(t('error.leaveHR', 'Unavailable to leave help at this time.'))
            console.error(error)
        },
    })
    return { leaveHR, ...rest }
}
